const FINGERPRINT_SESSION_KEY = 'fingerprint_captured_session';

/**
 * Check if fingerprint has been captured in the current session
 * @returns {boolean}
 */
export const isFingerprintCapturedThisSession = () => {
  if (typeof window === 'undefined') return false;
  
  try {
    const captured = localStorage.getItem(FINGERPRINT_SESSION_KEY);
    return captured === 'true';
  } catch (error) {
    console.warn('Error reading fingerprint session from localStorage:', error);
    return false;
  }
};

/**
 * Mark fingerprint as captured for the current session
 */
export const setFingerprintCapturedThisSession = () => {
  if (typeof window === 'undefined') return;
  
  try {
    localStorage.setItem(FINGERPRINT_SESSION_KEY, 'true');
  } catch (error) {
    console.warn('Error storing fingerprint session in localStorage:', error);
  }
};

/**
 * Clear fingerprint session flag (call on logout)
 */
export const clearFingerprintSession = () => {
  if (typeof window === 'undefined') return;
  
  try {
    localStorage.removeItem(FINGERPRINT_SESSION_KEY);
    console.log('Fingerprint session cleared');
  } catch (error) {
    console.warn('Error clearing fingerprint session from localStorage:', error);
  }
};

/**
 * Send fingerprint data to backend via geolocation API
 * @param {string} visitorId - The fingerprint visitor ID
 * @param {number} id_usuario - The user ID
 * @returns {Promise}
 */
export const sendFingerprintToBackend = async (visitorId, id_usuario) => {
  try {
    console.log('Sending fingerprint to backend with:', { visitorId, id_usuario });
    
    // Check if visitorId is valid
    if (!visitorId) {
      throw new Error('VisitorId is null or undefined');
    }
    
    // Import UAParser for device information - fix the import syntax
    const UAParserModule = await import('ua-parser-js');
    const UAParser = UAParserModule.UAParser || UAParserModule.default;
    
    const ua = new UAParser(window.navigator.userAgent);
    
    const header = {
      browser: ua.getBrowser().name,
      os: ua.getOS().name,
      device: ua.getDevice().type,
      vendor: ua.getDevice().vendor,
      model: ua.getDevice().model,
    };

    console.log('Device header info:', header);

    const response = await fetch('/api/geolocation', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: id_usuario,
        header,
        location: null, // No location data for fingerprint-only sessions
        visitorId
      }),
    });

    const data = await response.json();
    
    if (response.ok) {
      console.log('Fingerprint sent to backend successfully via geolocation API');
      return data;
    } else {
      throw new Error(data.error || 'Failed to send fingerprint to backend');
    }
  } catch (error) {
    console.error('Error sending fingerprint to backend:', error);
    throw error;
  }
}; 